import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/landing';
import { SectionHeading } from './SectionHeading';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ivory py-12 md:py-24" data-id="element-71" data-mp="1gitw04isywjq">
      <div className="mx-auto max-w-[820px] px-5 md:px-8" data-id="element-72" data-mp="1glpv3w6dzr9r">
        <SectionHeading eyebrow="Before you start" title="Frequently asked" highlight="questions" data-id="element-73" data-mp="24a93sctcm62d" />
        <div className="space-y-3" data-id="element-74" data-mp="289q9968rz37j">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          const id = `faq-panel-${index}`;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-navy/[0.08] bg-white" data-id="element-75" data-mp="1zho9la6j5qyb" data-mpi={index}>
                <h3 data-id="element-76" data-mp="2n7a8rxmwk66b">
                  <button type="button" aria-expanded={isOpen} aria-controls={id} onClick={() => setOpen(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-base font-semibold text-navy focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-teal md:px-6" data-id="element-77" data-mp="2n6r0z9qyuy60">
                    {faq.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-teal transition-transform duration-200 ease-out motion-reduce:transition-none ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-78" data-mp="19sahw8phtzth" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-79" data-mp="1skmpb9v07rah">
                  {isOpen && <motion.div id={id} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-80" data-mp="35ew5v8i1r00">
                      <p className="px-5 pb-5 text-[15px] text-muted md:px-6" data-id="element-81" data-mp="238pugp1gocim">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}